<div class="stepper-container">
  @if (isReadOnly) {
    <div class="read-only-banner">
      <mat-icon>lock</mat-icon>
      <span>The {{ selectedPerformanceYear() }} submission window has closed. This submission is read-only.</span>
    </div>
  }

  <div class="stepper-content-wrapper">
    @if (isPacketDataLoading()) {
      <div class="loading-overlay">
        <mat-spinner></mat-spinner>
        <p>Loading submission...</p>
      </div>
    }

    <mat-stepper
      #stepper
      [linear]="true"
      orientation="horizontal"
      class="mips-stepper"
      (selectionChange)="onStepChange($event)"
    >
      <ng-template matStepperIcon="done">
        <mat-icon class="iconDisplay">check_circle</mat-icon>
      </ng-template>

    <!-- Step 1: Questionnaire -->
    <mat-step [completed]="isStepComplete(1)">
      <form [formGroup]="step1FormGroup">
        <ng-template matStepLabel><span matTooltip="Questionnaire">Questionnaire</span></ng-template>

        <ng-template #step1Actions>
          <div></div>
          <button
            mat-button
            color="primary"
            (click)="onNext(1)"
            [disabled]="(!step1FormGroup.valid && !isReadOnly) || isNavigating || isPacketDataLoading()"
          >
            Next
          </button>
        </ng-template>

        <div class="stepper-actions">
          <ng-container [ngTemplateOutlet]="step1Actions"></ng-container>
        </div>

        <div class="step-content" [class.read-only-content]="isReadOnly">
          <app-mips-questionnaire (yearChange)="onQuestionnaireYearChange($event)" [syncedPerformanceYear]="selectedPerformanceYear()"></app-mips-questionnaire>
        </div>

        <div class="stepper-actions">
          <ng-container [ngTemplateOutlet]="step1Actions"></ng-container>
        </div>
      </form>
    </mat-step>

    <!-- Step 2: Eligibility -->
    <mat-step [stepControl]="step2FormGroup" [completed]="isStepComplete(2)">
      <form [formGroup]="step2FormGroup">
        <ng-template matStepLabel><span matTooltip="Eligibility">Eligibility</span></ng-template>

        <div class="stepper-actions">
          <button mat-button (click)="onBack()" [disabled]="isNavigating">
            Back
          </button>
          <button
            mat-button
            color="primary"
            [disabled]="(!step2FormGroup.valid && !isReadOnly) || isNavigating || (isReadOnly && !currentPacket()?.id)"
            (click)="onNext(2)"
          >
            Next
          </button>
        </div>

        <div class="step-content">
          <app-mips-eligibility [initialPerformanceYear]="selectedPerformanceYear()" (yearChange)="onEligibilityYearChange($event)"></app-mips-eligibility>
        </div>

        <div class="stepper-actions">
          <button mat-button (click)="onBack()" [disabled]="isNavigating">
            Back
          </button>
          <button
            mat-button
            color="primary"
            [disabled]="(!step2FormGroup.valid && !isReadOnly) || isNavigating || (isReadOnly && !currentPacket()?.id)"
            (click)="onNext(2)"
          >
            Next
          </button>
        </div>
      </form>
    </mat-step>

    <!-- Step 3: TIN Details -->
    <mat-step [stepControl]="step3FormGroup" [completed]="isStepComplete(3)">
      <form [formGroup]="step3FormGroup">
        <ng-template matStepLabel><span matTooltip="TIN Details">TIN Details</span></ng-template>

        <div class="stepper-actions">
          <button mat-button (click)="onBack()" [disabled]="isNavigating">
            Back
          </button>
          <button
            mat-button
            color="primary"
            [disabled]="(!step3FormGroup.valid && !isReadOnly) || isNavigating || isPacketDataLoading()"
            (click)="onNext(3)"
          >
            Next
          </button>
        </div>

        <div class="step-content" [class.read-only-content]="isReadOnly">
          <app-mips-tin-eligibility-details></app-mips-tin-eligibility-details>
        </div>

        <div class="stepper-actions">
          <button mat-button (click)="onBack()" [disabled]="isNavigating">
            Back
          </button>
          <button
            mat-button
            color="primary"
            [disabled]="(!step3FormGroup.valid && !isReadOnly) || isNavigating || isPacketDataLoading()"
            (click)="onNext(3)"
          >
            Next
          </button>
        </div>
      </form>
    </mat-step>

    <!-- Step 4: Settings -->
    <mat-step [stepControl]="step4FormGroup" [completed]="isStepComplete(4)">
      <form [formGroup]="step4FormGroup">
        <ng-template matStepLabel><span matTooltip="Settings">Settings</span></ng-template>

        <div class="stepper-actions">
          <button mat-button (click)="onBack()" [disabled]="isNavigating">
            Back
          </button>
          <button
            mat-button
            color="primary"
            [disabled]="(!step4FormGroup.valid && !isReadOnly) || isNavigating || isPacketDataLoading()"
            (click)="onNext(4)"
          >
            Next
          </button>
        </div>

        <div class="step-content" [class.read-only-content]="isReadOnly">
          <app-mips-settings [parentForm]="step4FormGroup"></app-mips-settings>
        </div>

        <div class="stepper-actions">
          <button mat-button (click)="onBack()" [disabled]="isNavigating">
            Back
          </button>
          <button
            mat-button
            color="primary"
            [disabled]="(!step4FormGroup.valid && !isReadOnly) || isNavigating || isPacketDataLoading()"
            (click)="onNext(4)"
          >
            Next
          </button>
        </div>
      </form>
    </mat-step>

    <!-- Step 5: Quality -->
    <mat-step [stepControl]="step5FormGroup" [completed]="isStepComplete(5)">
      <form [formGroup]="step5FormGroup">
        <ng-template matStepLabel><span matTooltip="Quality Measures">Quality</span></ng-template>

        <div class="stepper-actions">
          <button mat-button (click)="onBack()" [disabled]="isNavigating">
            Back
          </button>
          <button
            mat-button
            color="primary"
            [disabled]="(!step5FormGroup.valid && !isStepExcluded(5) && !isReadOnly) || isNavigating || isPacketDataLoading()"
            (click)="onNext(5)"
          >
            Next
          </button>
        </div>

        <div class="step-content" [class.read-only-content]="isReadOnly">
          <app-mips-quality [parentForm]="step5FormGroup"></app-mips-quality>
        </div>

        <div class="stepper-actions">
          <button mat-button (click)="onBack()" [disabled]="isNavigating">
            Back
          </button>
          <button
            mat-button
            color="primary"
            [disabled]="(!step5FormGroup.valid && !isStepExcluded(5) && !isReadOnly) || isNavigating || isPacketDataLoading()"
            (click)="onNext(5)"
          >
            Next
          </button>
        </div>
      </form>
    </mat-step>

    <!-- Step 6: Promoting Interoperability -->
    <mat-step [stepControl]="step6FormGroup" [completed]="isStepComplete(6)">
      <form [formGroup]="step6FormGroup">
        <ng-template matStepLabel><span matTooltip="Promoting Interoperability">PI</span></ng-template>

        <div class="stepper-actions">
          <button mat-button (click)="onBack()" [disabled]="isNavigating">
            Back
          </button>
          <button
            mat-button
            color="primary"
            [disabled]="(!step6FormGroup.valid && !isStepExcluded(6) && !isReadOnly) || isNavigating || isPacketDataLoading()"
            (click)="onNext(6)"
          >
            Next
          </button>
        </div>

        <div class="step-content" [class.read-only-content]="isReadOnly">
          <app-mips-pi [parentForm]="step6FormGroup"></app-mips-pi>
        </div>

        <div class="stepper-actions">
          <button mat-button (click)="onBack()" [disabled]="isNavigating">
            Back
          </button>
          <button
            mat-button
            color="primary"
            [disabled]="(!step6FormGroup.valid && !isStepExcluded(6) && !isReadOnly) || isNavigating || isPacketDataLoading()"
            (click)="onNext(6)"
          >
            Next
          </button>
        </div>
      </form>
    </mat-step>

    <!-- Step 7: Improvement Activities -->
    <mat-step [stepControl]="step7FormGroup" [completed]="isStepComplete(7)">
      <form [formGroup]="step7FormGroup">
        <ng-template matStepLabel><span matTooltip="Improvement Activities">IA</span></ng-template>

        <div class="stepper-actions">
          <button mat-button (click)="onBack()">Back</button>
          <button
            mat-button
            color="primary"
            [disabled]="(!step7FormGroup.valid && !isStepExcluded(7) && !isReadOnly) || isSaving() || isPacketDataLoading()"
            (click)="onNext(7)"
          >
            <mat-spinner *ngIf="isSaving()" diameter="20"></mat-spinner>
            <ng-container *ngIf="!isSaving()"> Next </ng-container>
          </button>
        </div>

        <div class="step-content" [class.read-only-content]="isReadOnly">
          <app-mips-ia [parentForm]="step7FormGroup"></app-mips-ia>
        </div>

        <div class="stepper-actions">
          <button mat-button (click)="onBack()">Back</button>
          <button
            mat-button
            color="primary"
            [disabled]="(!step7FormGroup.valid && !isStepExcluded(7) && !isReadOnly) || isSaving() || isPacketDataLoading()"
            (click)="onNext(7)"
          >
            <mat-spinner *ngIf="isSaving()" diameter="20"></mat-spinner>
            <ng-container *ngIf="!isSaving()"> Next </ng-container>
          </button>
        </div>
      </form>
    </mat-step>

    <!-- Step 8: DRCF -->
    <mat-step [stepControl]="step8FormGroup" [completed]="isStepComplete(8)">
      <form [formGroup]="step8FormGroup">
        <ng-template matStepLabel><span matTooltip="Data Release Consent Form">DRCF</span></ng-template>

        <div class="stepper-actions">
          <button mat-button (click)="onBack()" [disabled]="isNavigating">
            Back
          </button>
          <button
            mat-button
            color="primary"
            [disabled]="(!step8FormGroup.valid && !isReadOnly) || isNavigating || isPacketDataLoading()"
            (click)="onNext(8)"
          >
            Next
          </button>
        </div>

        <div class="step-content">
          <app-mips-drcf [parentForm]="step8FormGroup" [isReadOnly]="isReadOnly"></app-mips-drcf>
        </div>

        <div class="stepper-actions">
          <button mat-button (click)="onBack()" [disabled]="isNavigating">
            Back
          </button>
          <button
            mat-button
            color="primary"
            [disabled]="(!step8FormGroup.valid && !isReadOnly) || isNavigating || isPacketDataLoading()"
            (click)="onNext(8)"
          >
            Next
          </button>
        </div>
      </form>
    </mat-step>

    <mat-step [stepControl]="step9FormGroup" [completed]="isStepComplete(9)">
      <ng-template matStepLabel><span matTooltip="Review & Submit">Review & Submit</span></ng-template>

      <div class="stepper-actions">
        <button mat-button (click)="onBack()" [disabled]="isNavigating || submitSuccess()">
          Back
        </button>
        <button
          mat-button
          color="primary"
          [disabled]="!submitSuccess() || isNavigating || isPacketDataLoading()"
          (click)="onNext(9)"
        >
          Next
        </button>
      </div>

      <div class="step-content">
        <app-mips-submission-confirmation [isReadOnly]="isReadOnly" [isOpenedFromAdminReview]="isOpenedFromAdminReview()"></app-mips-submission-confirmation>
      </div>

      <div class="stepper-actions">
        <button mat-button (click)="onBack()" [disabled]="isNavigating || submitSuccess()">
          Back
        </button>
        <button
          mat-button
          color="primary"
          [disabled]="!submitSuccess() || isNavigating || isPacketDataLoading()"
          (click)="onNext(9)"
        >
          Next
        </button>
      </div>
    </mat-step>

    <!-- Step 10: Submission Score (only accessible after successful submission) -->
    <mat-step [stepControl]="step10FormGroup" [completed]="false" [editable]="false">
      <ng-template matStepLabel><span matTooltip="Submission Results">Results</span></ng-template>

      <div class="step-content">
        <app-mips-submission-score></app-mips-submission-score>
      </div>
    </mat-step>
    </mat-stepper>
  </div>
</div>
